import { TaskPreference } from '@demind-inc/core';
import {
  DEFAULT_TASK_DURATION_MIN,
  useAuthContext,
  usePreferences,
  useUpdateTaskPref,
} from '../data-access';

export const useTaskSettings = () => {
  const { user } = useAuthContext();
  const { taskPreferences } = usePreferences({ preferenceId: user.preferenceId! });
  const { updateTaskPref, isPending } = useUpdateTaskPref();

  const handleTaskSettingsChange = (newSettings: Partial<TaskPreference>) => {
    updateTaskPref({ preferenceId: user.preferenceId!, preferences: newSettings });
  };

  const taskSettings = {
    ...taskPreferences,
    durationMin: taskPreferences?.durationMin || DEFAULT_TASK_DURATION_MIN,
  };

  return {
    taskSettings,
    handleTaskSettingsChange,
    isPending,
  };
};